import { background } from './renegades.mjs'
import { imgproxySettings, mobileImgproxySettings } from './shared.mjs'

export const body = {
  id: 'body',
  name: 'Body',
  imgproxySettings,
  mobileImgproxySettings,
  hasOptions: false,
  pathTemplate: 'gs://sg360/240730/Houston Astros/MLB-R_astros-{nnn}.png',
}

export default {
  supports360: false,
  layers: [background, body],
  resolveOptions: () => ({}),
}
